import type { FaireProductEntity } from "../../entity_types/product";

export const p_h5uqe2bc2q: FaireProductEntity = {
  token: "p_h5uqe2bc2q",
  type: "product",
  name: "Crystal Prescriptions 6: Ancestral Clearing, Karmic Healing",
  brandToken: "b_elwnrzazbf",
  brandName: "Microcosm Publishing & Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/efb7e527fab47a840569061f27aef5e45ac39eaa6e83eee356d994ffa0e043b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5556ae5bc2dde49b9dc89ce57cab8bc124358d3571c5ea3e25dd485c911caa1b.jpeg",
    "https://cdn.faire.com/fastly/cd44046ddfdbfdec4b2ec186b4cb04b096c9b72a58a4d1ae6df808fa2fe10c54.jpeg",
  ],
  priceDollars: 19.36,
  description:
    '(Volume 6) Crystal Prescriptions: Crystals for Ancestral Clearing, Soul Retrieval, Spirit Release and Karmic Healing. An A-Z Guide\nThis practical sixth book in the Crystal Prescriptions series covers crystals for karmic clearing, soul integration, and healing the family tree. People are hampered by inherited ancestral memories, attitudes, and beliefs, which are carried in each person\'s so-called "junk DNA." By utilizing the extraordinary healing power of crystals, learn how to work through inherited and past-life burdens quickly, easily, and without having to relive the trauma and dramas of your personal karmic history. As you heal your past, you strive to create a future that generations to come will benefit from—a life blessed by a garnered soul and ancestral wisdom without baggage. Includes an A-to-Z directory of appropriate crystals that assists you to identify exactly the right crystal for your needs. (medium discount)',
  tags: [],
  msrpDollars: 27.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:36.125Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
